import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader, Text } from "@mantine/core";
export const ImageLoading = () => {
    return (_jsx("div", { style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 1)",
            zIndex: 20,
            // aspectRatio: "1/1",
        }, children: _jsx("div", { style: { height: "100%", paddingTop: 200 }, children: _jsxs("div", { style: { textAlign: "center" }, children: [_jsx(Loader, { size: "md", color: "blue" }), _jsx(Text, { size: "sm", color: "dimmed", mt: "xs", children: "Loading image..." })] }) }) }));
};
